export const setCookie = (name, value, exdays = 1000) => {
    let expires = '';

    if (exdays !== false) {
        // cookie without expiration is session cookie;
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        expires = `expires=${d.toUTCString()};`;
    }

    document.cookie = `${name}=${value};${expires}path=/`;
};

export const getCookie = name => {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : false;
};

export const deleteCookie = name => {
    setCookie(name, '', -1);
};

export function deleteAllCookies(exceptionsList = []) {
    document.cookie.split(';').forEach(c => {
        const cookieName = c.substr(0, c.indexOf('=')).trim();

        if (!exceptionsList.includes(cookieName)) {
            document.cookie = c
                .replace(/^ +/, '')
                .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        }
    });
}
